import { createContext } from "react";

const BankTransferContext = createContext();

export default BankTransferContext;
